export const CNPJ_SIZE = 14;
// Máscara alfanumérica: 'A' aceita letra ou dígito (ngx-mask); os 2 dígitos
// verificadores são sempre numéricos ('0'). Suporta tanto o CNPJ numérico
// legado quanto o novo CNPJ alfanumérico (RFB, jul/2026).
export const CNPJ_MASK = 'AA.AAA.AAA/AAAA-00';

const PESOS_DV1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const PESOS_DV2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

// Valor do caractere para o módulo 11: ASCII - 48 ('0'..'9' -> 0..9, 'A'..'Z' -> 17..42).
function charValue(char: string): number {
  return char.charCodeAt(0) - 48;
}

function mod11(base: string, pesos: number[]): number {
  let sum = 0;
  for (let i = 0; i < base.length; i++) {
    sum += charValue(base.charAt(i)) * pesos[i];
  }
  const rest = sum % 11;
  return rest < 2 ? 0 : 11 - rest;
}

export function CNPJValidation(cnpj: string): boolean {
  // Mantém letras e dígitos (CNPJ alfanumérico); descarta a máscara (. / -).
  cnpj = (cnpj ?? '').toUpperCase().replace(/[^0-9A-Z]/g, '');

  if (cnpj === '') return false;

  if (cnpj.length !== CNPJ_SIZE) return false;

  const base = cnpj.substring(0, 12);
  const dv = cnpj.substring(12);

  // Os 12 primeiros podem ser alfanuméricos; os 2 dígitos verificadores são sempre numéricos.
  if (!/^\d{2}$/.test(dv)) return false;

  // Rejeita sequências repetidas apenas para CNPJ 100% numérico (regra do formato legado).
  if (/^\d{14}$/.test(cnpj) && /^(\d)\1{13}$/.test(cnpj)) return false;

  const d1 = mod11(base, PESOS_DV1);
  const d2 = mod11(base + d1, PESOS_DV2);

  return dv === `${d1}${d2}`;
}
